import PouchDB from 'pouchdb-core'
import mapReduce from 'pouchdb-mapreduce'
import httpAdapter from 'pouchdb-adapter-http'
import authentication from 'pouchdb-authentication'

import { remoteDBUrl } from './config'

PouchDB
  .plugin(mapReduce)
  .plugin(httpAdapter)
  .plugin(authentication)

const opts = {
  skipSetup: true,
  ajax: {
    timeout: 60000
  }
}

export const db = new PouchDB(remoteDBUrl + '/forth', opts)
export const userDb = new PouchDB(remoteDBUrl + '/_users', opts)
export const productDB = new PouchDB(remoteDBUrl + '/forth-products', opts)
export const locationsDB = new PouchDB(remoteDBUrl + '/forth-locations', opts)
export const paymentsDB = new PouchDB(remoteDBUrl + '/forth-payments', opts)
export const pluckDocs = (alldocs) => {
  return alldocs.rows.map((row) => {
    return row.doc
  })
}



// WEBPACK FOOTER //
// ./src/helpers/db.js